import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { CONTACT, SERVICES, NAV_LINKS } from "../../data/site";
import { SocialLinks } from "./SocialLinks";
import { useCookiePreferences } from "./CookieConsent";

export const Footer = () => {
  const { openPreferences } = useCookiePreferences();
  return (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-obsidian">
    <div className="mx-auto max-w-7xl px-5 pt-16 sm:px-8">
      <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
        Crafting Ireland's <span className="text-amber">High Streets</span>
      </h2>

      <div className="mt-12 grid gap-10 border-t border-white/10 pt-12 md:grid-cols-4">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">Navigate</p>
          <ul className="mt-4 space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <Link to={l.href} className="text-sm text-white/70 transition-colors hover:text-amber">
                  {l.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">Services</p>
          <ul className="mt-4 space-y-2">
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s.id}>
                <Link to="/services" className="text-sm text-white/70 transition-colors hover:text-amber">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">Contact</p>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-amber" />
              <a href={CONTACT.phoneHref} className="hover:text-amber">{CONTACT.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <MessageCircle size={16} className="text-amber" />
              <a href={CONTACT.whatsappHref} target="_blank" rel="noreferrer" className="hover:text-amber">
                WhatsApp {CONTACT.whatsapp}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-amber" />
              <a href={CONTACT.emailHref} className="hover:text-amber">{CONTACT.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-amber" />
              <span>{CONTACT.address}</span>
            </li>
          </ul>
          <SocialLinks className="mt-6" />
        </div>
      </div>

      <div className="flex flex-col items-start justify-between gap-3 border-t border-white/10 pb-28 pt-8 sm:flex-row sm:items-center lg:pb-8">
        <p className="font-mono text-xs uppercase tracking-wider text-white/40">
          © {new Date().getFullYear()} Shop Front Makers · Ireland
        </p>
        <p className="font-mono text-xs uppercase tracking-wider text-white/40">
          Design · Production · Construction
        </p>
        <button
          type="button"
          data-testid="footer-cookie-preferences"
          onClick={openPreferences}
          className="min-h-11 py-2 text-sm text-white/75 underline underline-offset-4 transition-colors hover:text-amber focus-visible:outline focus-visible:outline-amber"
        >
          Cookie preferences
        </button>
      </div>
    </div>
  </footer>
  );
};
